import { Component, OnInit } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { VerifyEmailService } from './verify-email.service';

@Component({
    selector: 'emailData/verifyEmail',
    providers: [VerifyEmailService],
    template: require('./verify-email.component.html')
})

export class SuperUserVerifyEmailComponent implements OnInit {

    emailKey: string;

    constructor(private _verifyEmailService: VerifyEmailService, private route: ActivatedRoute, private _parentRouter: Router) {
        this.emailKey = route.snapshot.params['emailKey'];
    }

    ngOnInit() {
        console.log(this.emailKey);
        this._verifyEmailService.verifyEmail(this.emailKey);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/verify_email/verify-email.component.ts
 **/